/* @ngInject */
const railwayLabel = (
  valueHandler
) => {
  const self = {}

  self.class = 'Commande'
  self.title = 'Commandes'

  self.fields = {
    id: {
      text: 'Id de la commande',
      messages: {
        invalid: 'L\'id de la commande est invalide',
      },
    },
    selectCommande: {
      text: 'Sélectionner la commande',
      choice: 'Choix de la commande',
    },
    selectId: {
      text: 'Sélectionner la commande',
      choice: 'Choix de la commande',
    },
    name: {
      text: 'Nom de la commande',
      messages: {
        invalid: 'Le nom de commande est invalide',
        exists: 'Ce nom de commande existe déjà',
      },
    },
    location: {
      text: 'Localisation',
      messages: { },
    },
    wagonCount: {
      text: 'Nombre de wagons',
    },
  }

  self.statements = {
    new: 'Nouvelle commande',
    edit: (_commandeName) => 'Modification de la commande ' + _commandeName,
    cancelModification: 'Annuler les modifications',
    list: 'Liste des commandes',
    exists: 'Ce numéro de commande existe déjà',
    consult: 'Consulter les commandes',
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
  }

  self.log = {
    save: {
      success: 'La commande a bien été créée.',
      failure: 'Une erreur est survenue lors de la création de la commande.',
      alreadyExists: 'Cette commande existe déjà',
    },
    update: {
      success: 'La commande a bien été modifiée.',
      failure: 'Une erreur est survenue lors de la modification de la commande.',
    },
    delete: {
      success: 'La commande a bien été supprimée.',
      failure: 'Une erreur a interrompu la suppression de la commande.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucune commande ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 commande a été trouvée.'
        } else if (_length > 1) {
          return _length + ' commandes ont été trouvées.'
        }
        return 'Commande recherchée.'
      },
      failure: 'Impossible de rechercher les commandes',
      noResult: 'Aucune commande ne correspond à cette recherche',
    },
  }

  return self
}

export default railwayLabel



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/resources/labels.resource.js